import { render, staticRenderFns } from "./AccountSellerAdd.vue?vue&type=template&id=94219c76&"
import script from "./AccountSellerAdd.vue?vue&type=script&lang=js&"
export * from "./AccountSellerAdd.vue?vue&type=script&lang=js&"
import style0 from "./AccountSellerAdd.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports